import PropTypes from "prop-types";
import LineChart from "./LineChart";

function EvolucionTemporalChart({ data, period, customDates }) {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <LineChart
          data={data}
          period={period}
          customDates={customDates}
          title="Evolución Temporal de Atenciones por Motivo"
          height={400}
          legendPosition="right"
          showFilter={true}
          filterLabel="Motivos"
          defaultSelectedCount={4}
          noDataMessage="No hay datos disponibles para el período seleccionado"
          noSelectionMessage="Selecciona al menos un motivo para visualizar el gráfico"
          stepSize={20}
          tension={0.4}
          useConsistentColors={true}
        />
      </div>
    </div>
  );
}

EvolucionTemporalChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.number),
      })
    ),
  }),
  period: PropTypes.string.isRequired,
  customDates: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default EvolucionTemporalChart;
